import { useQuery } from '@tanstack/react-query';

import { handleApiCall } from '@/api/utils/handleApiCall';
import { useAuth } from '@/context/AuthProvider';
import { usePropertyManager } from '@/context/PropertyManagerProvider';

import { Contact } from './useGetAllContacts';

export type ApiResponse_Get_Contact = Contact;

export type ApiRequest_Get_Contact = {
  location_id: number;
};

const ENDPOINT = 'contacts';
const METHOD = 'GET';

export const QUERY_KEY = (contactId?: number, locationId?: number) => [
  'contacts',
  'single',
  contactId,
  locationId,
];

export const useGetContact = (contactId: number, enabled = true) => {
  const { session } = useAuth();
  const { selectedPropertyLocation } = usePropertyManager();

  return useQuery({
    queryKey: QUERY_KEY(contactId, selectedPropertyLocation?.id),
    queryFn: async (): Promise<ApiResponse_Get_Contact> => {
      if (!selectedPropertyLocation?.id) {
        throw new Error('No location selected');
      }

      return handleApiCall<ApiResponse_Get_Contact, ApiRequest_Get_Contact>(
        session,
        METHOD,
        `${ENDPOINT}/${contactId}`,
        {
          location_id: selectedPropertyLocation.id,
        }
      );
    },
    enabled: enabled && !!selectedPropertyLocation?.id && !!session && !!contactId,
  });
};
